var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
document.addEventListener("DOMContentLoaded", () => {
  const watchingDiv = document.querySelector("[data-results-live-update]");
  const questionsContainer = document.querySelector("[data-questions-container]");
  const questionTemplate = document.getElementById("question-0");
  const optionTemplate = document.querySelector("[data-option-template]");
  if (!watchingDiv) {
    return;
  }
  const url = watchingDiv.dataset.resultsLiveUpdate;
  const optionVoteCountTexts = () => document.querySelectorAll("[data-option-votes-count-text]");
  const optionVotePercentTexts = () => document.querySelectorAll("[data-option-votes-percent-text]");
  const optionVoteWidths = () => document.querySelectorAll("[data-option-votes-width]");
  const questionTotalVotesTexts = () => document.querySelectorAll("[data-question-total-votes-text]");
  const animateText = (element, value) => {
    if (element.textContent === value) {
      return;
    }
    element.textContent = value;
    element.classList.add("live_results-number_changing");
    setTimeout(() => {
      element.classList.remove("live_results-number_changing");
    }, 1e3);
  };
  const digQuestionValue = (questionId, data, key) => {
    const questions = data.questions || [];
    const question = questions.find((item) => item.id === parseInt(questionId, 10));
    if (!question || !(key in question)) {
      return null;
    }
    return question[key];
  };
  const digOptionValue = (questionId, optionId, data, key) => {
    data.questions = data.questions || [];
    const question = data.questions.find((item) => item.id === parseInt(questionId, 10));
    if (!question) {
      return null;
    }
    const responseOptions = question.response_options || [];
    if (!Array.isArray(responseOptions)) {
      return null;
    }
    const option = responseOptions.find((item) => item.id === parseInt(optionId, 10));
    if (!option) {
      return null;
    }
    if (key in option) {
      return option[key];
    }
    return null;
  };
  const createAdditionalQuestions = (data) => {
    if (!questionTemplate || !questionsContainer || !optionTemplate) {
      return;
    }
    const questions = data.questions || [];
    const additionalQuestions = questions.filter((question) => !document.getElementById(`question-${question.id}`) && question.published_results);
    additionalQuestions.forEach((question) => {
      const questionElement = questionTemplate.cloneNode(true);
      questionElement.id = `question-${question.id}`;
      questionElement.classList.remove("hidden");
      questionElement.querySelector("[data-question-body]").textContent = question.body;
      const totalVotesElement = questionElement.querySelector("[data-question-total-votes-text]");
      if (totalVotesElement) {
        totalVotesElement.dataset.questionTotalVotesText = question.id;
        totalVotesElement.textContent = question.total_votes_text || "";
      }
      const optionsContainer = questionElement.querySelector("[data-options-container]");
      question.response_options.forEach((option) => {
        const optionElement = optionTemplate.cloneNode(true);
        optionElement.classList.remove("hidden");
        optionElement.querySelector("[data-option-body]").textContent = option.body;
        optionElement.querySelector("[data-option-votes-count-text").dataset.optionVotesCountText = `${question.id},${option.id}`;
        optionElement.querySelector("[data-option-votes-percent-text").dataset.optionVotesPercentText = `${question.id},${option.id}`;
        optionElement.querySelector("[data-option-votes-width").dataset.optionVotesWidth = `${question.id},${option.id}`;
        optionsContainer.appendChild(optionElement);
      });
      questionsContainer.appendChild(questionElement);
    });
  };
  const fetchResults = () => __async(null, null, function* () {
    try {
      const response = yield fetch(url, {
        method: "GET",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = yield response.json();
      createAdditionalQuestions(data);
      optionVoteCountTexts().forEach((el) => {
        const [questionId, optionId] = el.dataset.optionVotesCountText.split(",");
        const val = digOptionValue(questionId, optionId, data, "votes_count_text");
        if (val) {
          animateText(el, val);
        }
      });
      optionVotePercentTexts().forEach((el) => {
        const [questionId, optionId] = el.dataset.optionVotesPercentText.split(",");
        const val = digOptionValue(questionId, optionId, data, "votes_percent_text");
        if (val) {
          animateText(el, val);
        }
      });
      optionVoteWidths().forEach((el) => {
        const [questionId, optionId] = el.dataset.optionVotesWidth.split(",");
        const val = digOptionValue(questionId, optionId, data, "votes_percent");
        if (val) {
          el.style.width = `${val}%`;
        }
      });
      questionTotalVotesTexts().forEach((el) => {
        const questionId = el.dataset.questionTotalVotesText;
        const val = digQuestionValue(questionId, data, "total_votes_text");
        if (val) {
          animateText(el, val);
        }
      });
      if (data.ongoing) {
        setTimeout(fetchResults, 4e3);
      }
    } catch (error) {
      console.error("Error fetching results:", error);
    }
  });
  fetchResults();
});
